import axiosClient from './axiosClient';

export const getParents = (params?: Record<string, any>) => {
    return axiosClient.get('/parents', { params });
};

export const createParent = (data: Record<string, any>) => {
    return axiosClient.post('/parents', data);
};

export const updateParent = (id: string, data: Record<string, any>) => {
    return axiosClient.put(`/parents/${id}`, data);
};

export const deleteParent = (id: string) => {
    return axiosClient.delete(`/parents/${id}`);
};

export const uploadParentAvatar = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/parents/${id}/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getDashboardStats = () => {
    return axiosClient.get('/parents/dashboard/stats');
};

export const getSubmissionDetail = (submissionId: string) => {
    return axiosClient.get(`/parents/submissions/${submissionId}`);
};

export const submitGrade = (submissionId: string, data: { score: number, feedback: string }) => {
    return axiosClient.patch(`/parents/submissions/${submissionId}/grade`, data);
};
